<section class="reviews-carousel-item"
         [class.mobile]="deviceService.isMobile()">
  <div class="user">
    <div class="avatar-wrap">
      <on-ui-cover [cover]="avatar"></on-ui-cover>
    </div>

    <span class="name">{{ review.reporterName }}</span>
  </div>

  <div class="review-wrap">
    <div class="lug">
      <app-icon width="18" height="38" icon="review-wrap-lug"></app-icon>
    </div>

    <div class="top">
      <div class="rating-wrap">
        <div *ngFor="let item of [1, 2, 3, 4, 5]; trackBy: trackByFn"
             class="rating-item"
             [class.active]="item <= review.rating">
          <app-icon class="icon" icon="rating"></app-icon>
        </div>
      </div>
      <span class="date">{{ reviewDate | dfnsFormat: 'LLLL dd, yyyy' }}</span>
    </div>
    <p class="comment">{{ review.comment }}</p>
  </div>
</section>
